// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"PartnerList-primaryButton-pJ_2Bn","appSummaryContent":"PartnerList-appSummaryContent-1jAJcS"};